import request from '@/utils/request'
const BASE_URL = '/PrintFields'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/GetList',
      method: 'post',
      data
    })
  },
  info(data) {
    return request({
      url: BASE_URL + '/GetInfo',
      method: 'post',
      data
    })
  },
}